import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Components/SearchInput';
import municipalityAPI from '../../Network/Municipality';
import Cookies from "universal-cookie";

const cookies = new Cookies();

export default function Search({
    filters,
    setFilters
}) {
    const [t] = useTranslation("common");
    const timerMunicipalities = useRef(null)
    const [municipalities, setMunicipalities] = useState([])
    const [loadingMunicipalities, setLoadingMunicipalities] = useState(false)
    const [searchTermMunicipality, setSearchTermMunicipality] = useState("");

    const headerObject = {
        username: cookies.get("user_name") || null,
        user_id: cookies.get("user_id") || null,
        account_name: cookies.get("account_name") || null,
        account_id: cookies.get("account_id") || null,
        authHash: cookies.get("authHash") || null,
        sid: cookies.get("sid") || null,
        baseurl: cookies.get("baseUrl") || null,
        id: cookies.get("id") || null,
    }

    const loadInitialMunicipalities = async () => {
        setLoadingMunicipalities(true);
        const result = await municipalityAPI.getMunicipalities({
            params: {
                ...headerObject,
                page_size: 10,
                page: 1
            }
        })
        setLoadingMunicipalities(false);
        if (result.status && result?.data?.data?.data) {
            setMunicipalities(result?.data?.data?.data)
        }
    }

    useEffect(() => {
        loadInitialMunicipalities()
    }, [])

    const handleSearchTermMunicipalityChange = (newValue) => {
        setSearchTermMunicipality(newValue);
        if (timerMunicipalities.current) {
            clearTimeout(timerMunicipalities?.current)
        }
        timerMunicipalities.current = setTimeout(async () => {
            if (newValue?.length >= 3) {
                setLoadingMunicipalities(true);
                const result = await municipalityAPI.getMunicipalities({
                    params: {
                        ...headerObject,
                        name: newValue,
                        page_size: 20,
                        page: 1
                    }
                })
                setLoadingMunicipalities(false);
                if (result.status && result?.data?.data?.data) {
                    setMunicipalities(result?.data?.data?.data)
                }
            } else if (newValue?.length === 0) {
                loadInitialMunicipalities()
            } else {
                setMunicipalities([])
            }
        }, 1000)
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100% !important",
            }}
        >
            <SearchInput
                value={filters?.name}
                setValue={(value) => {
                    setFilters({
                        ...filters,
                        name: value
                    })
                }}
                title={t('GLOBAL.name')}
            />
            <SearchInput
                value={filters?.code}
                setValue={(value) => {
                    setFilters({
                        ...filters,
                        code: value
                    })
                }}
                title={t('GLOBAL.code')}
            />
            <Autocomplete
                sx={{
                    ml: 1.5, mt: 1, mb: 1, width: '95%',
                    '& .MuiFormLabel-root,& .MuiInputBase-input': {
                        fontFamily: 'Cairo-Medium'
                    }
                }}
                onInputChange={(event, newInputValue) => {
                    handleSearchTermMunicipalityChange(newInputValue);
                }}
                inputValue={searchTermMunicipality}
                loading={loadingMunicipalities}
                loadingText={t('GLOBAL.searching')}
                value={filters?.municipalities_selected ? filters?.municipalities_selected : []}
                options={municipalities?.length ? municipalities : []}
                multiple={true}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => {
                    return option && option?.name || ""
                }}
                onChange={(e, v) => {
                    setFilters({
                        ...filters,
                        municipality_ids: v?.length > 0 ? v?.map(m => m?.id) : [],
                        municipalities_selected: v
                    })
                }}
                renderInput={(params) => (
                    <TextField {...params}
                        placeholder={t('MIZAN_LIST.municipality') || 'البلدية'}
                        variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
                )}
            />
        </Box>
    );
}
